import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { AuthenticatedUser } from '@aveva/connect-web-core';
import { firstValueFrom } from 'rxjs';
import * as globals from '../globals';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HealthStats } from 'src/app/models/healthstats.model';
import { HealthStatsService } from 'src/app/services/healthstats.service';
import { LoggingService } from '../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-healthstats',
  templateUrl: './healthstats.component.html',
  styleUrl: './healthstats.component.scss'
})
export class HealthstatsComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    private healthstatsService: HealthStatsService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.getHealthStatsLastRefresh();
    this.getServicesHealthStats();    
  }

  private async getHealthStatsLastRefresh() {
    try {
      this.loadingSpinner(true);
      this.healthStatsLastRefresh = await firstValueFrom(this.healthstatsService.getHealthStatsLastRefresh());
      this.loadingSpinner(false);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner(false);
    }
  }

  private async getServicesHealthStats() {
    try {
      this.loadingSpinner(true);
      const servicesHealthStats = await firstValueFrom(this.healthstatsService.getServicesHealthStats());
      this.dataSource = new MatTableDataSource(servicesHealthStats);
      this.loadingSpinner(false);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner(false);
    }
  }
  
  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  loadingSpinner = (value: boolean) => this.isLoading = value;

  user: AuthenticatedUser;
  isLoading: boolean;
  displayedColumns: string[] = globals.healthstats_columns;
  dataSource = new MatTableDataSource<HealthStats>();
  healthStatsLastRefresh: string = '';

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
}
